import { useEffect } from "react";

function useMount(fn: () => void) {
  useEffect(() => {
    fn();
    // eslint-disable-next-line
  }, []);
}

export default useMount;
